<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2 class="page-title-h2">
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    چک لیست های من
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="" data-card-height="150" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
                <div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
                <div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
                <div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>




            <div v-if="true">
                <div class="card card-style bg-theme pb-0 overflow-visible z-index1000 mb-2">
                    <div class="row m-0 p-3">
                        <div class="col-6 pr-0 pl-1">
                            <div class="input-style input-style-2 input-required has-icon m-0">
                                <i class="input-icon fa fa-filter color-orange-dark"></i>
                                <em><i class="fa fa-angle-down"></i></em>
                                <select @change="filterList" v-model="type" class="form-control">
                                    <option value="unpassed">جاری</option>
                                    <option value="passed">بسته شده</option>
                                    <option value="all" selected>همه</option>
                                </select>
                            </div>                           
                        </div>
                        <div class="col-6 p-0">
                            <div class="search-box search-color bg-magenta1-light rounded-sm">
                                <i class="fa fa-search"></i>
                                <input type="text" class="border-0 pr-4" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                            </div>
                        </div>
                    </div>    
                </div>
                <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

                <div class="card card-style mb-2" @click.prevent="openDetails(task.checkListId)" v-for="task in CheckListList" :key="task.checkListId">
                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div p-2">
                            <div>
                                <i class="fa fa-calendar text-warning"></i>
                                <span class="text-muted d-inline-block text-left ltr">{{task.checkListDate}}</span>
                            </div>
                            <div>
                                <i class="fa fa-check color-red1-dark"></i>
                                <span class="font-weight-bold">{{task.subject}}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="d-flex justify-content-between" style="width:90%">
                                    <div>
                                        <i class="fa fa-user color-green2-light"></i>
                                        <span class="font-weight-bold">{{task.userTitle}}</span>
                                    </div>
                                    <div class="pl-3">
                                        <i class="fa fa-percent color-red1-light"></i>
                                        <b>{{task.passedRate}}</b>
                                    </div>
                                </div>
                                <span class="text-left" style="width:10%" @click.stop="showMenu(task.checkListId)"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card card-style" v-if="Loading==false && NoMoreData==false && CheckListList.length>0 && CheckListList.length%20==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100 py-5">
                            <button class="btn btn-outline-info" @click="getNextPageForCheckListList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>

                <div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>

                <div class="card card-style" v-if="CheckListList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">چک لیستی یافت نشد.</p>
                    </div>
                </div>
            </div>

            <div class="card card-style" v-else>
                <div class="content">
                    <h4 class="mb-0 text-center">تصاویر بخش چک لیست ها</h4>
                </div>
                <div class="divider mb-0"></div>
                <div class="gallery-view-controls d-flex justify-content-center">
                    <a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
                    <a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
                    <div class="clearfix"></div>
                </div>
                <div class="content my-n1">
                    <div class="gallery-views gallery-view-2">
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-1-L.jpg" title="چک لیست های من" class="default-link">
                            <img src="/assets/images/gallery/checkList-1-500x500.jpg" data-src="/assets/images/gallery/checkList-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">چک لیست های من</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-2-L.jpg" title="انتخاب نوع نمایش چک لیست ها" class="default-link">
                            <img src="/assets/images/gallery/checkList-2-500x500.jpg" data-src="/assets/images/gallery/checkList-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">انتخاب نوع نمایش چک لیست ها</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-3-L.jpg" title="لیست کارهای هر چک لیست" class="default-link">
                            <img src="/assets/images/gallery/checkList-3-500x500.jpg" data-src="/assets/images/gallery/checkList-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست کارهای هر چک لیست</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/checkList-4-L.jpg" title="ثبت یادآور برای هر یک از کارهای چک لیست" class="default-link">
                            <img src="/assets/images/gallery/checkList-4-500x500.jpg" data-src="/assets/images/gallery/checkList-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ثبت یادآور برای هر یک از کارهای چک لیست</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                    </div>
                </div>

                <a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>تهیه اشتراک اپلیکشن</a>
            </div>


        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" v-if="isFreeRegist!==true" :style="{top:addButtonTop}">
                <router-link to="/CreateCheckList" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CreateCheckList', params: { checkListId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="Share" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-share-alt text-warning float-right font-14"></i>اشتراک گذاری</span><i class="fa fa-angle-left"></i></button>

                    <button @click.prevent="copyCheckList" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-copy color-magenta2-dark float-right font-14"></i>کپی</span><i class="fa fa-angle-left"></i></button>
                    <button @click.prevent="deleteCheckList" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>

        <Help-Menu title="راهنمای ثبت چک لیست" keyEn="TaskList"></Help-Menu>
        <!--<div id="createCheckListHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای ثبت چک لیست</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="true">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3 show" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CheckList.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CheckList.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->


        <my-tour></my-tour>
    </div>

</template>

<script>
    import calendarFilter from '../Components/CalendarFilter.vue';
    import myTour from '../Tours/CheckListTour.vue'
    import HelpMenu from '../Components/HelpMenu.vue';
    import VueSimpleAlert from "vue3-simple-alert";
    export default {
        components: {
            "calendar-filter": calendarFilter,
            "Help-Menu": HelpMenu,
            myTour
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                type: "all",
                selectedWorkId: 0,
                pageLoaded: false,
                pageLoading: false,
                date: null
            };
        },
        computed: {
            CheckListList() {
                return this.$store.getters.GetCheckListList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetCheckListNoMoreData;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            UpdateCheckListList() {
                return this.$store.getters.GetUpdateCheckListList;
            },
        },

        created() {
            console.log(this.NoMoreData);

            this.$store.dispatch("GetCheckListListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey,
                date: this.date
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;

            },

            showMenu(checkListId) {
                this.selectedWorkId = checkListId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetCheckListListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    date: this.date,
                    type: this.type
                });
            },
            copyItem() {
                this.page = 1;
                this.$store.dispatch("GetCheckListListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            deleteCheckList() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("CheckList/DeleteCheckList?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.page = 0;
                                this.getNextPageForCheckListList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            Share() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.pageLoading = true;
                    setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)
                    var data = {
                        shareDoc: 4,
                        id: this.selectedWorkId
                    };
                    this.$http.post("CheckList/ShareDoc", data)
                        .then(data => {
                            this.pageLoading = false;
                            var res = data.data;
                            if (res.isSuccess) {
                                window.open(res.obj, '_blank');
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });

                });
            },
            copyCheckList() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به ثبت یک کپی از این چک لیست هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.pageLoading = true;
                    setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)

                    this.$http.get("CheckList/CopyCheckList?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data;
                            if (!isNaN(res)) {
                                this.$router.push({ name: 'CreateCheckList', params: { checkListId: res } });
                            }
                            else {
                                this.showErrorMessage(res);
                            }
                            this.pageLoading = false;

                        });
                });
            },
            openDetails(checkListId) {
                this.$router.push({ name: 'CreateCheckList', params: { checkListId: checkListId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForCheckListList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetCheckListListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    date: this.date
                });
            },
            selectDate(d) {
                this.date = d;
                this.page = 0;
                this.getNextPageForCheckListList();
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateCheckListList == true) {
                this.page = 0;
                this.getNextPageForCheckListList();
            }

        },
        mounted() {
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
